import React, { useEffect, useRef, useState } from "react";
import TestimonialCard from "../TestimonialCard";
import "../../../styles/components/logoMarquee.scss";
import { LOGOS_DURATION } from "../../../constants";

const HeroKusamaRotatingText = ({ data, cardColor, duration, leftToRight }) => {
  const validItems = data?.filter((item) => item?.text?.text);
  const shouldSplit = validItems.length > 8;
  const midpoint = Math.ceil(validItems.length / 2);
  const firstRow = shouldSplit ? validItems.slice(0, midpoint) : validItems;
  const secondRow = shouldSplit ? validItems.slice(midpoint) : [];

  return (
    <div
  
      className={`hero-kusama-text-list mx-6 sm:mx-12 xl:mx-0 gap-2.5 max-w-[288px] xs:max-w-sm sm:max-w-2xl md:max-w-4xl xl:max-w-6xl overflow-hidden gap_class`}
    >
      <InfiniteLoopSlider duration={duration || LOGOS_DURATION} reverse={true}>
        {firstRow.map((item, index) => (
          <p
            key={`row1-${index}`}
            className="text-base herokusama-rotating-section  min-w-fit  font-manrope rounded-full px-4 py-2 border font-semibold tracking-[-0.4px]"
          >
            {item.text.text}
          </p>
        ))}
      </InfiniteLoopSlider>

      {shouldSplit && (
        <InfiniteLoopSlider
          duration={duration || LOGOS_DURATION}
          reverse={false}
        >
          {secondRow.map((item, index) => (
            <p
              key={`row2-${index}`}
              className="text-base herokusama-rotating-section min-w-fit w-full font-manrope rounded-full px-4 py-2 border font-semibold tracking-[-0.4px]"
            >
              {item.text.text}
            </p>
          ))}
        </InfiniteLoopSlider>
      )}

      <div className="fade" />
    </div>
  );
};

export default HeroKusamaRotatingText;

const InfiniteLoopSlider = ({ children, duration, reverse = false }) => {
  return (
    <div
      className="loop-slider herokusama-slide-opacity"
      style={{
        marginBottom: "10px",
        "--duration": `${duration}ms`,
        "--direction": reverse ? "reverse" : "normal",
      }}
    >
      <div className="inner">
        {children}
        {children}
      </div>
    </div>
  );
};
